// extracted by mini-css-extract-plugin
export var alertIcon = "_ub-0";